export enum ItAccreditationResponseOrgStatusEnum {
  ACTIVE = 'CANCELED',
  CANCELED = 'CANCELED',
  ABSENT = 'ABSENT',
}

export const ItAccreditationResponseOrgStatusDictionary = {
  ACTIVE: 'Действует',
  CANCELED: 'Аннулирована',
  ABSENT: 'Отсутствует',
  UNKNOWN: 'Неизвестный',
};
